import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import { isEqual } from 'lodash';
import { getProcessedFilter } from '../../../util/CrosstabUtils';
import MMECellContent from './MMECellContent';
import * as mmeUtils from '../../../util/MMEUtils';
import MMEColumnHeader from './MMEColumnHeader';
import MMEFirstHeaderColumn from './MMEFirstHeaderColumn';
import MMEDCRCellContent from './MMEDCRCellContent';
import MMEDCRColumnHeader from './MMEDCRColumnHeader';
import { ALL_ROWS_LABEL } from '../../mme/MMEConstants';


class MMEGridView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      crosstabTitle: '',
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.handleScrollBarWidth();
    }, 2000);
    window.addEventListener('resize', this.handleScrollBarWidth);
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.tableData.crosstabPerStudy, this.props.tableData.crosstabPerStudy)) {
      this.handleScrollBarWidth();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleScrollBarWidth);
  }

  getCrosstabTitle = () => this.state.crosstabTitle;

  handleScrollBarWidth = () => {
    $.fn.hasHScrollBar = () => {
      return $('#main-content-grid').get(0) ?
        $('#main-content-grid').get(0).scrollWidth > $('#main-content-grid').width() : null;
    };
    $.fn.getScrollWidth = () => {
      const $outer = $('<div>').css({ visibility: 'hidden', width: 100, overflow: 'scroll' }).appendTo('body');
      const widthWithScroll = $('<div>').css({ width: '100%' }).appendTo($outer).outerWidth();
      $outer.remove();
      return 100 - widthWithScroll;
    };
    const isHScrollBar = $('#main-content-grid').hasHScrollBar();
    if (isHScrollBar) {
      const scrollWidth = $().getScrollWidth();
      if ($('.empty-table-mme-last-row').length > 0) {
        $('.empty-table-mme-last-row').remove();
      }
      if ($('.empty-table-mme-last-row').length === 0) {
        $('.main-content-grid-left').append(
          `<div class="empty-table-mme-last-row" style="height:${scrollWidth}px;line-height:${scrollWidth}px"></div>`);
      }
    }
    $.fn.hasVScrollBar = () => {
      if (!isHScrollBar) {
        if ($('.empty-table-mme-last-row').length !== 0) {
          $('.empty-table-mme-last-row').remove();
        }
        return $('#main-content-grid').get(0) ?
          $('#main-content-grid').get(0).scrollHeight > $('#main-content-grid').height() : null;
      }
      const scrollWidth = $().getScrollWidth();
      return $('#main-content-grid').get(0) ?
        $('#main-content-grid').get(0).scrollHeight + scrollWidth > $('#main-content-grid').height() : null;
    };

    const hasScrollBar = $('#main-content-grid').hasVScrollBar();
    if (hasScrollBar) {
      const scrollWidth = $().getScrollWidth();
      if (!$('.custom-mme-table')[0] && $('.empty-table-header-col').length === 0) {
        $('.c-table--header .c-table--row').append(`<span class="empty-table-header-col" style=
          "min-width:${scrollWidth}px;width:${scrollWidth}px"><div class="head"></div><div class="cell"></div></span>`);
      }
      // if ($('.custom-mme-table')[0] && $('.empty-table-header-col-mme').length === 0) {
      if ($('.custom-mme-table')[0]) {
        if ($('.empty-table-header-col-mme').length > 0) {
          $('.empty-table-header-col-mme').remove();
        }
        const { columnHeaderList } = this.props.tableData;
        const lastItem = columnHeaderList && columnHeaderList[columnHeaderList.length - 1];
        const getCellColor = mmeUtils.getColumnColor(lastItem.colorVal);
        $('.c-table--header .c-table--row').append(`<span class="empty-table-header-col-mme" style=
          "min-width:${scrollWidth}px;width:${scrollWidth}px"><div class="head"></div><div class="mid-cell" 
          style="background-color:${getCellColor}"></div><div class="cell mme-first-cell"></div></span>`);
      }
    } else if ($('.empty-table-header-col').length !== 0) {
      $('.empty-table-header-col').remove();
    } else if ($('.empty-table-header-col-mme').length !== 0) {
      $('.empty-table-header-col-mme').remove();
    }
  }

  saveTextChange = text => {
    this.setState({ crosstabTitle: text });
  }

  handleContentScroll = e => {
    const headerMenu = document.getElementById('top-header-column');
    const leftSideMenu = document.getElementById('left-menu-content');
    leftSideMenu.scrollTop = e.target.scrollTop;
    headerMenu.scrollLeft = e.target.scrollLeft;
  }

  render() {
    const { selectedBaseIndex, cellElementList, showSave = true, reportType, firstHeaderCellElementList } = this.props;
    const metricsList = cellElementList.map(item => { return item.isVisible; });
    const metricsCount = cellElementList.filter(item => item.isVisible);
    const { highlightAndFilter, columnHeaderList, crosstabPerStudy, sortOrder,
      sortKey, sortColumnIndex,
      } = this.props.tableData;
    const newHighlightAndFilter = getProcessedFilter(highlightAndFilter);
    const newRows = crosstabPerStudy[0][selectedBaseIndex].rowList;
    if ($('.empty-table-mme-last-row').length !== 0) {
      $('.empty-table-mme-last-row').remove();
    }
    if ($('.empty-table-header-col-mme').length > 0) {
      $('.empty-table-header-col-mme').remove();
    }
    if (columnHeaderList && newRows) {
      return (
        <div>
          <div className="row expanded main-table">
            <MMEFirstHeaderColumn
              handleCrosstabSaveButton={
                this.props.handleCrosstabSaveButton
              }
              highlightModal={this.props.highlightModal}
              highlightRadioButton={this.props.highlightRadioButton}
              onValueChange={this.saveTextChange}
              handleHighlightShowButton={this.props.handleHighlightShowButton}
              tableData={this.props.tableData}
              showSave={showSave}
              placeholder={this.props.placeholder}
              warningText={this.props.warningText}
              observation={newRows[0].observation}
              rowHeader={newRows[0].rowHeader}
              onSort={this.props.onSort}
              sortColumnIndex={sortColumnIndex}
              sortKey={sortKey}
              sortOrder={sortOrder}
              metricsList={firstHeaderCellElementList}
            />
            <div id="top-header-column" className="column right-column-width mme-right-column-width c-table-container">
              <div className="c-table">
                <div className="c-table--header">
                  <div className="c-table--row">
                    {reportType !== 'DCR' && columnHeaderList.map((item, index) => (
                      <MMEColumnHeader
                        key={uuid()}
                        header={item}
                        metricsList={metricsCount}
                        metricsCount={metricsCount.length}
                        onSort={this.props.onSort}
                        sortOrder={sortOrder}
                        sortKey={sortKey}
                        columnIndex={index}
                        sortColumnIndex={sortColumnIndex}
                        rowValues={newRows[0].cellList[index]}
                        reportType={reportType}
                      />))}
                    {reportType === 'DCR' && columnHeaderList.map((item, index) => (
                      <MMEDCRColumnHeader
                        key={uuid()}
                        header={item}
                        metricsList={metricsCount}
                        metricsCount={metricsCount.length}
                        onSort={this.props.onSort}
                        sortOrder={sortOrder}
                        sortKey={sortKey}
                        columnIndex={index}
                        sortColumnIndex={sortColumnIndex}
                        allRowValues={newRows[0].cellList[index]}
                      />))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row expanded main-content-grid mme-grid-view">
            <div className="column left-column-width main-content-grid-left" id="left-menu-content">
              {newRows.filter(row => row.rowHeader !== ALL_ROWS_LABEL).map(row => (
                <div key={uuid()} className="c-table--row row-header-fixed">
                <div className="left-header-content">
                  <button
                    type="button"
                    title={`${row.tooltipVal ? row.tooltipVal : row.rowHeader} ${
                      row.isRowLabelUpdated ? String.fromCharCode(185) : ''
                      }`}
                    className={row.rowHeader === ALL_ROWS_LABEL ? 
                      'mme-cell-value-first-row' : 'mme-cell-value-next-rows'}
                    data-class="obs-l"
                  >{row.rowHeader}<sup>{row.isRowLabelUpdated ? '1' : ''}</sup></button>
                  <span
                    className={row.rowHeader === ALL_ROWS_LABEL ?
                      'mme-cell-value-first-row' : 'mme-cell-value-next-rows'}
                    title={row.observation}
                    data-class="obs-v"
                  >{row.observation}</span>
                </div>
              </div>))}
            </div>
            <div
              id="main-content-grid"
              className="column right-column-width mme-right-column-width main-content-grid-right"
              onScroll={e => this.handleContentScroll(e)}>
              {newRows.filter(row => row.rowHeader !== ALL_ROWS_LABEL).map(newRow =>
                (<div key={uuid()} className="c-table--row">
                  {reportType !== 'DCR' && newRow.cellList.map((col, index) => (
                  <div key={uuid()} className="c-table-private-col">
                    <MMECellContent
                      cell={col}
                      rowHeader={newRow.rowHeader}
                      highlightAndFilter={highlightAndFilter}
                      metricsList={metricsList}
                      metricsCount={metricsCount.length}
                      newHighlightAndFilter={newHighlightAndFilter}
                      reportType={reportType}
                      index={index}
                    />
                  </div>))
                  }
                  {reportType === 'DCR' && newRow.cellList.map((col, index) => (
                  <div key={uuid()} className="c-table-private-col">
                    <MMEDCRCellContent
                      cell={col}
                      rowHeader={newRow.rowHeader}
                      highlightAndFilter={highlightAndFilter}
                      metricsList={metricsList}
                      metricsCount={metricsCount.length}
                      newHighlightAndFilter={newHighlightAndFilter}
                      index={index}
                    />
                  </div>))
                  }
                </div>)
              )}
            </div>
          </div>
        </div>
      );
    }
    return '';
  }
}

MMEGridView.propTypes = {
  tableData: PropTypes.shape({
    highlightAndFilter: PropTypes.shape({}),
    columnHeaderList: PropTypes.arrayOf(PropTypes.shape({})),
    crosstabPerStudy: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
      rowList: PropTypes.arrayOf(PropTypes.shape({
        observation: PropTypes.string,
        rowHeader: PropTypes.string,
        cellList: PropTypes.arrayOf(PropTypes.shape({})),
      }))
    }))),
    sortOrder: PropTypes.string,
    sortKey: PropTypes.string,
    sortColumnIndex: PropTypes.number,
  }),
  selectedBaseIndex: PropTypes.number,
  handleCrosstabSaveButton: PropTypes.func,
  highlightRadioButton: PropTypes.func,
  highlightModal: PropTypes.shape({}),
  cellElementList: PropTypes.arrayOf(PropTypes.shape({})),
  onSort: PropTypes.func,
  handleHighlightShowButton: PropTypes.func,
  showSave: PropTypes.bool,
  placeholder: PropTypes.string,
  warningText: PropTypes.string,
  reportType: PropTypes.string,
  firstHeaderCellElementList: PropTypes.arrayOf(PropTypes.shape({})),
};

export default MMEGridView;
